// Traduções do formulário de usuário — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'usuarios.form.tab.duplas': "Duplas",
    'usuarios.form.search.duplas': "Buscar por nome ou código da dupla",
    'usuarios.form.empty.duplas': "Nenhuma dupla cadastrada.",
    'usuarios.form.col.members': "Membros",
    'usuarios.form.semDuplaAviso': "Este operador não está em nenhuma dupla e, por isso, verá a Frente de Trabalho, o painel de descarga e as cargas vazios, mesmo com acesso a todos os contratos. Escolha ao menos uma dupla na aba Duplas.",
    'usuarios.form.escopoNaoCarregou': "Não foi possível carregar os vínculos deste usuário. Abrir o formulário assim mostraria zero itens selecionados, e salvar apagaria o acesso dele. Tente de novo.",
    'usuarios.form.newTitle': 'Novo usuário',
    'usuarios.form.editTitle': 'Editar usuário',
    'usuarios.form.eyebrowPortal': 'Portal',
    'usuarios.form.identity': 'Dados do usuário',
    'usuarios.form.field.name': 'Nome',
    'usuarios.form.field.email': 'E-mail',
    'usuarios.form.field.phone': 'Telefone',
    'usuarios.form.field.role': 'Papel',
    'usuarios.form.field.cargo': 'Cargo',
    'usuarios.form.cargo.sem': 'Sem cargo',
    'usuarios.form.cargo.buscar': 'Buscar cargo',
    'usuarios.form.cargo.ajudaSem': 'Sem cargo, as permissões desta pessoa são escolhidas uma a uma aqui embaixo.',
    'usuarios.form.cargo.ajudaCom': 'As permissões do cargo aparecem travadas e mudam para todos quando o cargo muda. Marque aqui só o que esta pessoa tem a mais.',
    'usuarios.form.field.customer': 'Cliente',
    'usuarios.form.field.customers': 'Clientes',
    'usuarios.form.help.customers': 'O primeiro é o principal. É dele o que este usuário criar.',
    'usuarios.form.field.active': 'Ativo',
    'usuarios.form.field.blocked': 'Bloqueado',
    'usuarios.form.emailLocked': 'O e-mail não pode ser alterado.',
    'usuarios.form.emailHint': 'Enviaremos uma senha temporária para este endereço.',
    'usuarios.form.role.staff_admin': 'Administrador da equipe',
    'usuarios.form.role.staff_operator': 'Operador da equipe',
    'usuarios.form.role.customer_admin': 'Administrador do cliente',
    'usuarios.form.role.customer_operator': 'Operador do cliente',
    'usuarios.form.access.title': 'Acesso',
    'usuarios.form.access.description':
      'Envia uma senha temporária nova por e-mail. A senha atual do usuário, se existir, continua valendo até ele usar a temporária.',
    'usuarios.form.access.resend': 'Reenviar acesso',
    'usuarios.form.access.sending': 'Enviando',
    'usuarios.form.access.sent': 'Senha temporária enviada para o e-mail do usuário.',
    'usuarios.form.tabsAria': 'Áreas de acesso do usuário',
    'usuarios.form.tab.permissions': 'Permissões',
    'usuarios.form.tab.customers': 'Clientes',
    'usuarios.form.tab.contracts': 'Contratos',
    'usuarios.form.tab.personnel': 'Pessoas',
    'usuarios.form.tab.fleet': 'Frotas',
    'usuarios.form.tab.places': 'Locais',
    'usuarios.form.tab.allBadge': 'Todos',
    'usuarios.form.permissions.description':
      'Marque o que este usuário pode ver e fazer em cada área.',
    'usuarios.form.superuser.scopes':
      'Administrador da equipe alcança todos os clientes, contratos, pessoas, frotas e locais.',
    'usuarios.form.unsaved': 'Alterações não salvas',
    'usuarios.form.save': 'Salvar usuário',
    'usuarios.form.leaveTitle': 'Sair sem salvar',
    'usuarios.form.leaveMessage': 'As alterações feitas neste formulário serão perdidas.',
    'usuarios.form.leaveConfirm': 'Sair sem salvar',
    'usuarios.form.stay': 'Continuar editando',
    'usuarios.form.emptyScopeTitle': 'Áreas sem nenhum item selecionado',
    'usuarios.form.emptyScopeMessage':
      'Este usuário não verá nenhum item nas áreas listadas. Confirme para salvar assim.',
    'usuarios.form.emptyScopeConfirm': 'Salvar assim mesmo',
    'usuarios.form.emptyScopeAlert':
      'Nenhum item selecionado. Escolha ao menos um item ou volte para acesso a todos.',
    'usuarios.form.created': 'Usuário criado.',
    'usuarios.form.updated': 'Usuário atualizado.',
    'usuarios.form.search.customers': 'Buscar por razão social, nome fantasia ou CNPJ',
    'usuarios.form.search.contracts': 'Buscar por número, nome, cliente, origem ou destino',
    'usuarios.form.search.personnel': 'Buscar por nome, matrícula ou documento',
    'usuarios.form.search.fleet': 'Buscar por placa, código ou nome',
    'usuarios.form.search.places': 'Buscar por nome, código, município ou UF',
    'usuarios.form.col.legalName': 'Razão social',
    'usuarios.form.col.tradeName': 'Nome fantasia',
    'usuarios.form.col.cnpj': 'CNPJ',
    'usuarios.form.col.number': 'Número',
    'usuarios.form.col.name': 'Nome',
    'usuarios.form.col.customer': 'Cliente',
    'usuarios.form.col.origin': 'Origem',
    'usuarios.form.col.destination': 'Destino',
    'usuarios.form.col.situation': 'Situação',
    'usuarios.form.col.front': 'Frente',
    'usuarios.form.col.staffCode': 'Matrícula',
    'usuarios.form.col.document': 'Documento',
    'usuarios.form.col.category': 'Categoria',
    'usuarios.form.col.base': 'Base',
    'usuarios.form.col.plate': 'Placa',
    'usuarios.form.col.code': 'Código',
    'usuarios.form.col.city': 'Município',
    'usuarios.form.col.uf': 'UF',
    'usuarios.form.empty.customers': 'Nenhum cliente cadastrado.',
    'usuarios.form.empty.contracts': 'Nenhum contrato cadastrado.',
    'usuarios.form.empty.personnel': 'Nenhuma pessoa cadastrada.',
    'usuarios.form.empty.fleet': 'Nenhum item de frota cadastrado.',
    'usuarios.form.empty.places': 'Nenhum local cadastrado.',
  },
  en: {
    'usuarios.form.tab.duplas': "Teams",
    'usuarios.form.search.duplas': "Search by team name or code",
    'usuarios.form.empty.duplas': "No team registered.",
    'usuarios.form.col.members': "Members",
    'usuarios.form.semDuplaAviso': "This operator belongs to no team, so the Work Front, the unloading board and the loads will show up empty, even with access to every contract. Pick at least one team in the Teams tab.",
    'usuarios.form.escopoNaoCarregou': "Could not load this user's assignments. Opening the form now would show zero items selected, and saving would wipe their access. Try again.",
    'usuarios.form.newTitle': 'New user',
    'usuarios.form.editTitle': 'Edit user',
    'usuarios.form.eyebrowPortal': 'Portal',
    'usuarios.form.identity': 'User details',
    'usuarios.form.field.name': 'Name',
    'usuarios.form.field.email': 'Email',
    'usuarios.form.field.phone': 'Phone',
    'usuarios.form.field.role': 'Role',
    'usuarios.form.field.cargo': 'Position',
    'usuarios.form.cargo.sem': 'No position',
    'usuarios.form.cargo.buscar': 'Search position',
    'usuarios.form.cargo.ajudaSem': 'Without a position, this person\'s permissions are chosen one by one below.',
    'usuarios.form.cargo.ajudaCom': 'The position\'s permissions are locked and change for everyone when the position changes. Tick here only what this person has on top of it.',
    'usuarios.form.field.customer': 'Customer',
    'usuarios.form.field.customers': 'Customers',
    'usuarios.form.help.customers': 'The first one is the main one. What this user creates belongs to it.',
    'usuarios.form.field.active': 'Active',
    'usuarios.form.field.blocked': 'Blocked',
    'usuarios.form.emailLocked': 'The email cannot be changed.',
    'usuarios.form.emailHint': 'We will send a temporary password to this address.',
    'usuarios.form.role.staff_admin': 'Team administrator',
    'usuarios.form.role.staff_operator': 'Team operator',
    'usuarios.form.role.customer_admin': 'Customer administrator',
    'usuarios.form.role.customer_operator': 'Customer operator',
    'usuarios.form.access.title': 'Access',
    'usuarios.form.access.description':
      "Sends a new temporary password by email. The user's current password, if any, remains valid until the temporary one is used.",
    'usuarios.form.access.resend': 'Resend access',
    'usuarios.form.access.sending': 'Sending',
    'usuarios.form.access.sent': "Temporary password sent to the user's email.",
    'usuarios.form.tabsAria': 'User access areas',
    'usuarios.form.tab.permissions': 'Permissions',
    'usuarios.form.tab.customers': 'Customers',
    'usuarios.form.tab.contracts': 'Contracts',
    'usuarios.form.tab.personnel': 'People',
    'usuarios.form.tab.fleet': 'Fleet',
    'usuarios.form.tab.places': 'Places',
    'usuarios.form.tab.allBadge': 'All',
    'usuarios.form.permissions.description':
      'Choose what this user can see and do in each area.',
    'usuarios.form.superuser.scopes':
      'The team administrator reaches every customer, contract, person, fleet item and place.',
    'usuarios.form.unsaved': 'Unsaved changes',
    'usuarios.form.save': 'Save user',
    'usuarios.form.leaveTitle': 'Leave without saving',
    'usuarios.form.leaveMessage': 'The changes made in this form will be lost.',
    'usuarios.form.leaveConfirm': 'Leave without saving',
    'usuarios.form.stay': 'Keep editing',
    'usuarios.form.emptyScopeTitle': 'Areas with no item selected',
    'usuarios.form.emptyScopeMessage':
      'This user will see no items in the listed areas. Confirm to save it this way.',
    'usuarios.form.emptyScopeConfirm': 'Save anyway',
    'usuarios.form.emptyScopeAlert':
      'No item selected. Choose at least one item or go back to full access.',
    'usuarios.form.created': 'User created.',
    'usuarios.form.updated': 'User updated.',
    'usuarios.form.search.customers': 'Search by legal name, trade name or tax id',
    'usuarios.form.search.contracts': 'Search by number, name, customer, origin or destination',
    'usuarios.form.search.personnel': 'Search by name, staff id or document',
    'usuarios.form.search.fleet': 'Search by plate, code or name',
    'usuarios.form.search.places': 'Search by name, code, city or state',
    'usuarios.form.col.legalName': 'Legal name',
    'usuarios.form.col.tradeName': 'Trade name',
    'usuarios.form.col.cnpj': 'Tax id',
    'usuarios.form.col.number': 'Number',
    'usuarios.form.col.name': 'Name',
    'usuarios.form.col.customer': 'Customer',
    'usuarios.form.col.origin': 'Origin',
    'usuarios.form.col.destination': 'Destination',
    'usuarios.form.col.situation': 'Situation',
    'usuarios.form.col.front': 'Front',
    'usuarios.form.col.staffCode': 'Staff id',
    'usuarios.form.col.document': 'Document',
    'usuarios.form.col.category': 'Category',
    'usuarios.form.col.base': 'Base',
    'usuarios.form.col.plate': 'Plate',
    'usuarios.form.col.code': 'Code',
    'usuarios.form.col.city': 'City',
    'usuarios.form.col.uf': 'State',
    'usuarios.form.empty.customers': 'No customer registered.',
    'usuarios.form.empty.contracts': 'No contract registered.',
    'usuarios.form.empty.personnel': 'No person registered.',
    'usuarios.form.empty.fleet': 'No fleet item registered.',
    'usuarios.form.empty.places': 'No place registered.',
  },
  es: {
    'usuarios.form.tab.duplas': "Duplas",
    'usuarios.form.search.duplas': "Buscar por nombre o código de la dupla",
    'usuarios.form.empty.duplas': "Ninguna dupla registrada.",
    'usuarios.form.col.members': "Miembros",
    'usuarios.form.semDuplaAviso': "Este operador no pertenece a ninguna dupla y por eso verá el Frente de trabajo, el panel de descarga y las cargas vacíos, incluso con acceso a todos los contratos. Elija al menos una dupla en la pestaña Duplas.",
    'usuarios.form.escopoNaoCarregou': "No se pudieron cargar los vínculos de este usuario. Abrir el formulario así mostraría cero elementos seleccionados, y guardar borraría su acceso. Inténtelo de nuevo.",
    'usuarios.form.newTitle': 'Nuevo usuario',
    'usuarios.form.editTitle': 'Editar usuario',
    'usuarios.form.eyebrowPortal': 'Portal',
    'usuarios.form.identity': 'Datos del usuario',
    'usuarios.form.field.name': 'Nombre',
    'usuarios.form.field.email': 'Correo',
    'usuarios.form.field.phone': 'Teléfono',
    'usuarios.form.field.role': 'Rol',
    'usuarios.form.field.cargo': 'Cargo',
    'usuarios.form.cargo.sem': 'Sin cargo',
    'usuarios.form.cargo.buscar': 'Buscar cargo',
    'usuarios.form.cargo.ajudaSem': 'Sin cargo, los permisos de esta persona se eligen uno a uno aquí abajo.',
    'usuarios.form.cargo.ajudaCom': 'Los permisos del cargo aparecen bloqueados y cambian para todos cuando cambia el cargo. Marque aquí solo lo que esta persona tiene de más.',
    'usuarios.form.field.customer': 'Cliente',
    'usuarios.form.field.customers': 'Clientes',
    'usuarios.form.help.customers': 'El primero es el principal. Lo que este usuario cree pertenece a él.',
    'usuarios.form.field.active': 'Activo',
    'usuarios.form.field.blocked': 'Bloqueado',
    'usuarios.form.emailLocked': 'El correo no se puede cambiar.',
    'usuarios.form.emailHint': 'Enviaremos una contraseña temporal a esta dirección.',
    'usuarios.form.role.staff_admin': 'Administrador del equipo',
    'usuarios.form.role.staff_operator': 'Operador del equipo',
    'usuarios.form.role.customer_admin': 'Administrador del cliente',
    'usuarios.form.role.customer_operator': 'Operador del cliente',
    'usuarios.form.access.title': 'Acceso',
    'usuarios.form.access.description':
      'Envía una nueva contraseña temporal por correo. La contraseña actual del usuario, si existe, sigue válida hasta que use la temporal.',
    'usuarios.form.access.resend': 'Reenviar acceso',
    'usuarios.form.access.sending': 'Enviando',
    'usuarios.form.access.sent': 'Contraseña temporal enviada al correo del usuario.',
    'usuarios.form.tabsAria': 'Áreas de acceso del usuario',
    'usuarios.form.tab.permissions': 'Permisos',
    'usuarios.form.tab.customers': 'Clientes',
    'usuarios.form.tab.contracts': 'Contratos',
    'usuarios.form.tab.personnel': 'Personas',
    'usuarios.form.tab.fleet': 'Flotas',
    'usuarios.form.tab.places': 'Lugares',
    'usuarios.form.tab.allBadge': 'Todos',
    'usuarios.form.permissions.description':
      'Elija lo que este usuario puede ver y hacer en cada área.',
    'usuarios.form.superuser.scopes':
      'El administrador del equipo alcanza todos los clientes, contratos, personas, flotas y lugares.',
    'usuarios.form.unsaved': 'Cambios sin guardar',
    'usuarios.form.save': 'Guardar usuario',
    'usuarios.form.leaveTitle': 'Salir sin guardar',
    'usuarios.form.leaveMessage': 'Los cambios hechos en este formulario se perderán.',
    'usuarios.form.leaveConfirm': 'Salir sin guardar',
    'usuarios.form.stay': 'Seguir editando',
    'usuarios.form.emptyScopeTitle': 'Áreas sin ningún elemento seleccionado',
    'usuarios.form.emptyScopeMessage':
      'Este usuario no verá ningún elemento en las áreas listadas. Confirme para guardarlo así.',
    'usuarios.form.emptyScopeConfirm': 'Guardar de todos modos',
    'usuarios.form.emptyScopeAlert':
      'Ningún elemento seleccionado. Elija al menos uno o vuelva al acceso total.',
    'usuarios.form.created': 'Usuario creado.',
    'usuarios.form.updated': 'Usuario actualizado.',
    'usuarios.form.search.customers': 'Buscar por razón social, nombre comercial o CNPJ',
    'usuarios.form.search.contracts': 'Buscar por número, nombre, cliente, origen o destino',
    'usuarios.form.search.personnel': 'Buscar por nombre, matrícula o documento',
    'usuarios.form.search.fleet': 'Buscar por placa, código o nombre',
    'usuarios.form.search.places': 'Buscar por nombre, código, municipio o UF',
    'usuarios.form.col.legalName': 'Razón social',
    'usuarios.form.col.tradeName': 'Nombre comercial',
    'usuarios.form.col.cnpj': 'CNPJ',
    'usuarios.form.col.number': 'Número',
    'usuarios.form.col.name': 'Nombre',
    'usuarios.form.col.customer': 'Cliente',
    'usuarios.form.col.origin': 'Origen',
    'usuarios.form.col.destination': 'Destino',
    'usuarios.form.col.situation': 'Situación',
    'usuarios.form.col.front': 'Frente',
    'usuarios.form.col.staffCode': 'Matrícula',
    'usuarios.form.col.document': 'Documento',
    'usuarios.form.col.category': 'Categoría',
    'usuarios.form.col.base': 'Base',
    'usuarios.form.col.plate': 'Placa',
    'usuarios.form.col.code': 'Código',
    'usuarios.form.col.city': 'Municipio',
    'usuarios.form.col.uf': 'UF',
    'usuarios.form.empty.customers': 'Ningún cliente registrado.',
    'usuarios.form.empty.contracts': 'Ningún contrato registrado.',
    'usuarios.form.empty.personnel': 'Ninguna persona registrada.',
    'usuarios.form.empty.fleet': 'Ningún elemento de flota registrado.',
    'usuarios.form.empty.places': 'Ningún lugar registrado.',
  },
}
